import { combineReducers } from "redux";
import { configureStore } from '@reduxjs/toolkit';
import { reducer as oidcReducer, loadUser } from "redux-oidc-2";
import { createUserManager } from "redux-oidc-2";
import { authSettings } from "../settings/authSettings";
import { baseApi } from "./api/baseApi";
import tabSlice from "./slices/tabSlice";
import revSlice from "./slices/revSlice";
import { useReduxSelector } from "./hooks/hooks";


const getUserManager = (revTenantId?: string) => {
    const params = new URLSearchParams(window.location.search);

    let setting = authSettings;
    if (revTenantId) {
        setting.authority = setting.authority.replace("/common", `/${revTenantId}`);
        setting.redirect_uri = `${window.location.origin}/signin-callback?revTenantId=${revTenantId}`;
    }

    return createUserManager(setting);

};

const rootReducer = combineReducers({
    auth: oidcReducer,
    tab: tabSlice,
    rev: revSlice,
    // ...other reducers
    [baseApi.reducerPath]: baseApi.reducer
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(baseApi.middleware),
    devTools: process.env.NODE_ENV !== 'production',
});

// Load user from storage on startup
loadUser(store, getUserManager());

export { getUserManager };
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;